import { useCallback, useEffect, useState } from 'react';
import { useWorkingDayStore } from '../infrastructure/working-day.store';
import { workingDayChipLabel } from '@/shared/lib/working-day';

/**
 * Reads the shared working-day selection for header + appointment views.
 */
export function useWorkingDay(): {
  dateKey: string;
  label: string;
  setDateKey: (dateKey: string) => void;
  setToday: () => void;
  setTomorrow: () => void;
} {
  const dateKey = useWorkingDayStore((s) => s.dateKey);
  const setDateKey = useWorkingDayStore((s) => s.setDateKey);
  const setToday = useWorkingDayStore((s) => s.setToday);
  const setTomorrow = useWorkingDayStore((s) => s.setTomorrow);

  return {
    dateKey,
    label: workingDayChipLabel(dateKey),
    setDateKey,
    setToday,
    setTomorrow,
  };
}

/**
 * Local yyyy-MM-dd state bidirectionally synced with the working-day store.
 */
export function useSyncedWorkingDayDate(): [string, (dateKey: string) => void] {
  const { dateKey, setDateKey } = useWorkingDay();
  const [localDate, setLocalDate] = useState(dateKey);

  useEffect(() => {
    setLocalDate(dateKey);
  }, [dateKey]);

  const setSyncedDate = useCallback(
    (next: string) => {
      setLocalDate(next);
      setDateKey(next);
    },
    [setDateKey],
  );

  return [localDate, setSyncedDate];
}
